import Accordion from './accordion';

document.addEventListener('DOMContentLoaded', () => {
    const accordionContainers = document.querySelectorAll('[role="tablist"]');

    accordionContainers.forEach(container => {
        const allowMultiple = container.dataset.allowMultiple === 'true';
        const transitionDuration = parseInt(container.dataset.transitionDuration) || 300;

        new Accordion(container, {
            allowMultiple,
            transitionDuration
        });
    });
});

export { Accordion };